import { defineMessages } from "react-intl";
import { defaultFormMessages } from "../shared/crud/form";

const formMessages = defineMessages({
  id: {
    id: "",
    defaultMessage: "",
  },
  originPropertyTicker: {
    id: "replicatePropertyForm.label.originPropertyTicker",
    defaultMessage: "Ticker del hotel origen",
  },
  targetPropertyTicker: {
    id: "replicatePropertyForm.label.targetPropertyTicker",
    defaultMessage: "Ticker del hotel destino",
  },
  options: {
    id: "replicatePropertyForm.label.options",
    defaultMessage: "Opciones",
  },
  migrateAri: {
    id: "createPropertyForm.label.migrateAri",
    defaultMessage: "Migrar ARI",
  },
  migrateInventory: {
    id: "createPropertyForm.label.migrateInventory",
    defaultMessage: "Migrar Inventario",
  },
});

export const messages = {
  ...defaultFormMessages,
  ...formMessages,
  ...defineMessages({
    entityName: {
      id: "replicateProperty.entityName",
      defaultMessage: "Replicate Property DB in devel",
    },
    save: { id: "default.replicate", defaultMessage: "Replicate" },
    successful: {
      id: "replicateProperty.toast.successful",
      defaultMessage:
        "Property replicate request sent. You should receive an email when process finish.",
    },
    ariRequiresInventory: {
      id: "replicateProperty.validation.ariRequiresInventory",
      defaultMessage: "Migrate ARI requires select the Migrate Inventory Lines option too",
    },
  }),
};
